import { MouseEvent } from 'react';
import { Vector } from '../../helpers/Vector';

export const getInElementPositionFromEvent = (event: MouseEvent, containerElement: HTMLDivElement): Vector => {
    const boundingClientRect = containerElement.getBoundingClientRect();
    return { x: event.clientX - boundingClientRect.left, y: event.clientY - boundingClientRect.top };
};
